import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import NutritionNav from '../navigation/NutritionNav';

import Overview from '../../pages/nutrition/Overview';
import Calendar from '../../pages/nutrition/Calendar';
import SavedMeals from '../../pages/nutrition/SavedMeals';
import SavedRecipes from '../../pages/nutrition/SavedRecipes';
import NutritionDatabase from '../../pages/nutrition/NutritionDatabase';
import Settings from '../../pages/nutrition/Settings';

const NutritionRouter = ({ match, location }) => {
  return (
    <NutritionNavTemplate>
      <Switch>
        <Redirect exact from="/nutrition" to="/nutrition/overview" />
        <Route path = {match.path + '/overview'} >
          <Overview />
        </Route>
        <Route path = {match.path + '/calendar'} >
          <Calendar />
        </Route>
        <Route path = {match.path + '/saved-meals'} >
          <SavedMeals />
        </Route>
        <Route path = {match.path + '/saved-recipes'} >
          <SavedRecipes />
        </Route>
        <Route path = {match.path + '/nutrition-database'} >
          <NutritionDatabase />
        </Route>
        <Route path = {match.path + '/settings'} >
          <Settings />
        </Route>
        
      </Switch>
    </NutritionNavTemplate>
  );
}

const NutritionNavTemplate = (props) => {
  return (
    <>
      <NutritionNav />
      {props.children}
    </>
  );
}

export default NutritionRouter;